import { Box, Button, CircularProgress, Stack } from "@mui/material";
import {
  AccountType,
  Color,
  ErrorCode,
  FontStyle,
  Slug,
  SurveyButtonStyle,
} from "../constants";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";

const styles = {
  blueExpand: {
    ...FontStyle.headingBody,
    fontSize: "14px",
    color: "#0672cb",
    cursor: "pointer",
    // textDecoration: "underline",
    paddingTop: "10px",
    "&:hover": {
      color: "#1033CC",
    },
  },
};
export const JobFontSize = {
  title: "20px",
  large: "16px",
  medium: "14px",
  small: "12px",
};

export const JobTag = ({ tag, nowrap = true }) => {
  if (!tag) return null;
  return (
    <Box
      sx={{
        // backgroundColor: "#BBB0D0",
        backgroundColor: Color.primary,
        // backgroundColor: Color.lightBlue,
        borderRadius: "10px",
        px: "10px",
        py: "5px",
        color: "#000",
        fontSize: "12px",
        letterSpacing: "0px",
        whiteSpace: nowrap ? "nowrap" : "normal",
      }}>
      {tag}
    </Box>
  );
};
export const JobFilterChip = ({ tag, displayName, remove, nowrap = true }) => {
  if (tag === undefined || tag === null) return null;
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      onClick={(e) => {
        e.stopPropagation();
        remove();
      }}
      sx={{
        // backgroundColor: "#BBB0D0",
        backgroundColor: Color.primary,
        boxShadow: "0px 0px 8px rgb(0 0 0 / 10%)",
        // backgroundColor: Color.lightBlue,
        borderRadius: "10px",
        px: "10px",
        py: "6px",
        height: "fit-content",
        color: "#000",
        fontSize: "14px",
        letterSpacing: "0px",
        // textTransform: "capitalize",
        whiteSpace: nowrap ? "nowrap" : "normal",
        userSelect: "none",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: Color.primaryLight,
          // transform: "scale(1.05)",
        },
        "&:active": {
          backgroundColor: Color.primaryDark,
        },
      }}>
      <ClearIcon
        sx={{
          fontSize: "12px",
          // color: "#444",
          // opacity: 0.8,
        }}
      />
      <Box>{displayName}</Box>
    </Stack>
  );
};
// used as a state for JobFiltersBar
export const defaultFilters = {
  roles: [],
  locations: [],
  experienceLevels: [],
};

export const JobFloatScreen = ({ zIndex = 1001 }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        width: "100%",
        height: "100%",
        left: 0,
        zIndex: zIndex,
        backgroundColor: "#9994",
        pointerEvents: "none",
        // zIndex: 1,
      }}
    />
  );
};

export const getExperienceTag = ({ roleToken, experienceLevel }) => {
  if (roleToken === "Gig Work") return "Gig";
  if (experienceLevel >= 3) return "Senior";
  if (experienceLevel >= 2) return "Mid-Level";
  if (experienceLevel >= 1) return "Entry Level";
  if (experienceLevel === 0) return "Internship";
  return null;
};

export const jobButtonStyle = {
  ...FontStyle.headingBody,
  fontSize: JobFontSize.medium,
  backgroundColor: Color.primary,
  color: "#000",
  borderRadius: "4px",
  // py: '10px',
  minHeight: "40px",
  py: "10.75px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  px: "20px",
  width: "100%",
  maxWidth: "fit-content",
  minWidth: "",
  cursor: "pointer",
  "&:hover": {
    // color: Color.primary,
    // backgroundColor: Color.primaryDark,
    backgroundColor: Color.primaryLight,
  },
  "&:active": {
    backgroundColor: Color.primaryLight,
  },
};

const bulletWidthRaw = 36;
const bulletWidth = `${bulletWidthRaw}px`;
const bulletRightPadding = "10px";
// {'i', 'div', 'h4', 'h2', 'h3', 'b', 'p', 'li'}
const DangerousRowInner = ({ rowType, txt }) => {
  // lind-1-a
  if (rowType.startsWith("lind-")) {
    const splitType = rowType.split("-");
    const widthMult = parseInt(splitType[1]) + 1;
    const width = `${widthMult * bulletWidthRaw}px`;
    const bulletChar = splitType[2];
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}>
        <span
          style={{
            display: "inline-block",
            paddingRight: bulletRightPadding,
            width: width,
            minWidth: width,
            textAlign: "right",
          }}>
          {bulletChar}.
        </span>{" "}
        <span dangerouslySetInnerHTML={{ __html: txt }}></span>
      </div>
    );
  }

  return rowType === "i" ? (
    <i dangerouslySetInnerHTML={{ __html: txt }}></i>
  ) : rowType === "div" ? (
    <div dangerouslySetInnerHTML={{ __html: txt }}></div>
  ) : rowType === "x-div" ? (
    <div
      style={{ paddingTop: "8px" }}
      dangerouslySetInnerHTML={{ __html: txt }}></div>
  ) : rowType === "h4" ? (
    <h4 dangerouslySetInnerHTML={{ __html: txt }}></h4>
  ) : rowType === "h2" ? (
    <h2 dangerouslySetInnerHTML={{ __html: txt }}></h2>
  ) : rowType === "h3" ? (
    <h3 dangerouslySetInnerHTML={{ __html: txt }}></h3>
  ) : rowType === "b" ? (
    // <div style={{ paddingTop: "12px", paddingBottom: "8px" }}>
    <b dangerouslySetInnerHTML={{ __html: txt }}></b>
  ) : // </div>
  rowType === "b-inline" ? (
    <b dangerouslySetInnerHTML={{ __html: txt }}></b>
  ) : rowType === "p" ? (
    <p dangerouslySetInnerHTML={{ __html: txt }}></p>
  ) : rowType === "li" ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}>
      <span
        style={{
          display: "inline-block",
          paddingRight: bulletRightPadding,
          width: bulletWidth,
          minWidth: bulletWidth,
          textAlign: "right",
        }}>
        •
      </span>{" "}
      <span dangerouslySetInnerHTML={{ __html: txt }}></span>
    </div>
  ) : rowType.startsWith("li-") ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}>
      <span
        style={{
          display: "inline-block",
          paddingRight: bulletRightPadding,
          width: bulletWidth,
          minWidth: bulletWidth,
          textAlign: "right",
        }}>
        {rowType.replace("li-", "")}.
      </span>{" "}
      <span dangerouslySetInnerHTML={{ __html: txt }}></span>
    </div>
  ) : (
    <span dangerouslySetInnerHTML={{ __html: txt }}></span>
  );
};
const TaggedRowInner = ({ rowType, text, blur = false }) => {
  if (rowType.startsWith("html-")) {
    return (
      <DangerousRowInner rowType={rowType.replace("html-", "")} txt={text} />
    );
  }

  // lind-1-a
  if (rowType.startsWith("lind-")) {
    const splitType = rowType.split("-");
    const widthMult = parseInt(splitType[1]) + 1;
    const width = `${widthMult * bulletWidthRaw}px`;
    const bulletChar = splitType[2];
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}>
        <span
          style={{
            display: "inline-block",
            paddingRight: bulletRightPadding,
            width: width,
            minWidth: width,
            textAlign: "right",
          }}>
          {bulletChar}.
        </span>{" "}
        {text}
      </div>
    );
  }

  return rowType === "i" ? (
    <i>{text}</i>
  ) : rowType === "img" ? (
    <img
      src={text}
      width="80%"
      style={{ marginLeft: "10%", ...(blur && { filter: "blur(8px)" }) }}
      // style={{ marginLeft: "10%", filter: "blur(8px)" }}
    />
  ) : rowType === "div" ? (
    <div>{text}</div>
  ) : rowType === "x-div" ? (
    <div style={{ paddingTop: "8px" }}>{text}</div>
  ) : rowType === "h4" ? (
    <h4>{text}</h4>
  ) : rowType === "h2" ? (
    <h2>{text}</h2>
  ) : rowType === "h3" ? (
    <h3>{text}</h3>
  ) : rowType === "b" ? (
    // <div style={{ paddingTop: "12px", paddingBottom: "8px" }}>
    <b>{text}</b>
  ) : // </div>
  rowType === "b-inline" ? (
    <b>{text}</b>
  ) : rowType === "p" ? (
    <p>{text}</p>
  ) : rowType === "li" ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}>
      <span
        style={{
          display: "inline-block",
          paddingRight: bulletRightPadding,
          width: bulletWidth,
          minWidth: bulletWidth,
          textAlign: "right",
        }}>
        •
      </span>{" "}
      {text}
    </div>
  ) : rowType.startsWith("li-") ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}>
      <span
        style={{
          display: "inline-block",
          paddingRight: bulletRightPadding,
          width: bulletWidth,
          minWidth: bulletWidth,
          textAlign: "right",
        }}>
        {rowType.replace("li-", "")}.
      </span>{" "}
      {/* if text is a function, call it */}
      {typeof text === "function" ? text() : text}
      {/* {text} */}
    </div>
  ) : (
    <span>{text}</span>
  );
};
// wrapper for the row that handles the show more button
export const TaggedRow = ({ row, trimIdx, setShowMore, blur = false }) => {
  // if trimIdx is a function or list
  if (Array.isArray(trimIdx)) {
    return (
      <>
        <TaggedRowInner rowType={trimIdx[0]} text={trimIdx[1]} blur={blur} />
        <Stack
          sx={{
            ...styles.blueExpand,
          }}
          direction="row"
          onClick={() => setShowMore(true)}>
          View More{" "}
          <KeyboardArrowDownIcon sx={{ transform: "translateY(-2px)" }} />
        </Stack>
      </>
    );
  } else if (typeof trimIdx === "function") {
    return (
      <>
        <TaggedRowInner rowType={row[0]} text={trimIdx} blur={blur} />
        <Stack
          sx={{
            ...styles.blueExpand,
          }}
          direction="row"
          onClick={() => setShowMore(true)}>
          View More{" "}
          <KeyboardArrowDownIcon sx={{ transform: "translateY(-2px)" }} />
        </Stack>
      </>
    );
  } else if (trimIdx > 0) {
    return (
      <>
        <TaggedRowInner
          rowType={row[0]}
          text={row[1].slice(0, trimIdx) + "..."}
          blur={blur}
        />
        <Stack
          sx={{
            ...styles.blueExpand,
          }}
          direction="row"
          onClick={() => setShowMore(true)}>
          View More{" "}
          <KeyboardArrowDownIcon sx={{ transform: "translateY(-2px)" }} />
        </Stack>
      </>
    );
  } else {
    return <TaggedRowInner rowType={row[0]} text={row[1]} blur={blur} />;
  }
};

// https://drive.google.com/uc?export=download&id=FILEID
export const JobDownloads = {
  resumeTemplate:
    "https://docs.google.com/document/d/1hu34mKwUmS32em_ScA6YCQzcW786t9hhtyZkOlwKG0k/export?format=pdf",
  outreach_template: {
    name: "Download Outreach Template",
    // 1BBjuMGJpI1ZN6ER4zzEvKBYsJTG23ZxE
    url: "https://drive.google.com/uc?export=download&id=1BBjuMGJpI1ZN6ER4zzEvKBYsJTG23ZxE",
  },
  thankyou_template: {
    //networking followup
    name: "Download Follow Up & Thank You Template",
    shortName: "Download Template",
    url: "https://drive.google.com/uc?export=download&id=1ZjlwhK3WtFzbaik3avpFRE1S1auTOY7k",
  },
  oneonone_template: {
    name: "Download 1:1 Template",
    // https://drive.google.com/file/d/1H5YdQWKFX6FtZ2bLMmdsz9XViRt56O3y/view?usp=sharing
    url: "https://drive.google.com/uc?export=download&id=1H5YdQWKFX6FtZ2bLMmdsz9XViRt56O3y",
  },
  interview_followup: {
    // https://drive.google.com/file/d/1kp3MI39k7-hgKUBpVgyHOO3--GmxCgLx/view?usp=sharing
    name: "Download Follow Up Template",
    url: "https://drive.google.com/uc?export=download&id=1kp3MI39k7-hgKUBpVgyHOO3--GmxCgLx",
  },
  engineer_cv_letter: {
    name: "Download Cover Letter Template",
    url: "https://drive.google.com/uc?export=download&id=1MR_ojHL7sAG0L-kWFcatrc6I4u6Qt6Ez",
  },
  berkeley_resume_workshop: {
    name: "Download Workshop Slides",
    url: "https://drive.google.com/uc?export=download&id=17gf994xwKELEYPqO8b4qOHiGON0T0Mmu",
  },
};
// export const JobDownloads = {
//   resumeTemplate:
//     "https://docs.google.com/document/d/1hu34mKwUmS32em_ScA6YCQzcW786t9hhtyZkOlwKG0k/export?format=pdf",
//   outreach_template: {
//     name: "Download Outreach Template",
//     url: "https://docs.google.com/document/d/1i7O1K-5IyZiHF7g5RmodbuK-BS64hztxdC41chwiIBs/export?format=pdf",
//   },
//   thankyou_template: {
//     name: "Download Follow Up & Thank You Template",
//     shortName: "Download Template",
//     url: "https://docs.google.com/document/d/168GF7B4NHpbNW_j4aSrEf5uCu2GgdJ2_ml4KQT8Bl78/export?format=pdf",
//   },
//   oneonone_template: {
//     name: "Download 1:1 Template",
//     url: "https://docs.google.com/document/d/19tBGF0Ozfo5B7suW1ExoOWEGMIdixs2szDE_6Cd8lA0/export?format=pdf",
//   },
//   interview_followup: {
//     name: "Download Follow Up Template",
//     url: "https://docs.google.com/document/d/1jigAuj2OYmb9ME2d1x-qFHv7erEnXj1UgySxTDFHKLw/export?format=pdf",
//   },
// };

export const DownloadTemplateWrapper = ({ href, children }) => {
  return (
    <a
      style={{
        textDecoration: "none",
        color: "inherit",
      }}
      href={href}
      target="_blank"
      download="Resume Template.pdf">
      {children}
    </a>
  );
};

export const LoaderOrError = ({ error }) => {
  const auth = useSelector((state) => state.auth);
  const isGig = auth.accountData.accountType === AccountType.gig;
  if (error === null) return <CircularProgress />;
  if (error === ErrorCode.noSurveyData)
    return (
      <Stack direction="column" spacing={4}>
        <Box>Please complete your survey first!</Box>
        <a href={!isGig ? Slug.surveyInitial : Slug.surveyGigInitial}>
          <Button
            sx={{
              ...SurveyButtonStyle.defaultStyling,
              ...SurveyButtonStyle.primaryColorScale,
              maxWidth: "400px",
            }}
            disableRipple
            fullWidth>
            Job Search Preferences
          </Button>
        </a>
      </Stack>
    );
  if (error === ErrorCode.noJobMatches)
    return "No jobs were found for your search criteria at the moment. In the meantime, feel free to update your search preferences to receive more relevant job matches!";
  return "An error occurred. Please try again later.";
};
